// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const beautifly: PokeData = {
  "id": 267,
  "name": "beautifly",
  "height": 10,
  "weight": 284,
  "base_experience": 178,
  "types": [
    PokeType.BUG,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "whirlwind",
    "tackle",
    "poison-sting",
    "absorb",
    "mega-drain",
    "stun-spore",
    "string-shot",
    "rage",
    "harden",
    "leech-life",
    "protect",
    "giga-drain",
    "attract",
    "morning-sun",
    "air-cutter",
    "silver-wind",
    "iron-defense",
    "air-slash",
    "bug-buzz",
    "bug-bite",
    "venoshock",
    "quiver-dance"
  ],
  "moves": [
    "gust",
    "tackle",
    "stun-spore",
    "string-shot",
    "protect",
    "morning-sun",
    "air-slash",
    "bug-buzz",
    "bug-bite",
    "signal-spam",
    "aerial-ace",
    "tailwind",
    "roost"
  ],
  "evolution_chain": {
    "id": 135,
    "item": null,
    "species": [
      {
        "name": "wurmple",
        "order": 290,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "silcoon",
        "order": 291,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": 265,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 7,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "beautifly",
        "order": 292,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 266,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 10,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "cascoon",
        "order": 293,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": 265,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 7,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "dustox",
        "order": 294,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": 268,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 10,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 100,
    "speed": 118,
    "ability_power": 182
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
